<span mat-dialog-title>{{ 'ACCOUNT.FORGOT_PASSWORD.TITLE' | translate }}</span>
<div mat-dialog-content>
  <p>{{ 'ACCOUNT.FORGOT_PASSWORD.INFO' | translate }}</p>
</div>
<ng-container *ngIf="formState$ | async as formState">
  <mat-form-field appearance="fill" class="email-input">
    <mat-label>{{ 'ACCOUNT.FORGOT_PASSWORD.EMAIL_ADDRESS' | translate }}</mat-label>
    <input matInput type="text" [ngrxFormControlState]="formState"
  /></mat-form-field>
</ng-container>
<div mat-dialog-actions>
  <button mat-button mat-dialog-close class="dark-plain-button">{{ 'GENERAL.CANCEL' | translate }}</button>
  <button mat-flat-button color="primary" (click)="onSubmit()">
    {{ 'ACCOUNT.FORGOT_PASSWORD.RESET' | translate }}
  </button>
</div>
